export const onErrorHandler = (
  e: React.SyntheticEvent<HTMLImageElement, Event>,
  imgPath: string
) => {
  const target = e.target as HTMLImageElement;
  if (target instanceof HTMLImageElement) {
    target.src = imgPath;
  }
};
